
import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Mitchell',
      location: 'Miami, FL',
      rating: 5,
      text: 'Voltis saved the day when our AC broke during a heatwave! The technician arrived within 2 hours, diagnosed the problem quickly, and had us cool again in no time. Professional, friendly, and reasonably priced. Highly recommend!',
      service: 'Air Conditioning Repair'
    },
    {
      name: 'James Rodriguez',
      location: 'Orlando, FL',
      rating: 5,
      text: 'We had a major plumbing emergency at 2 AM, and Voltis was there within the hour. The plumber was knowledgeable, efficient, and cleaned up everything perfectly. Their 24/7 service is a lifesaver. Will definitely use them again!',
      service: 'Emergency Plumbing'
    },
    {
      name: 'Emily Thompson',
      location: 'Tampa, FL',
      rating: 5,
      text: 'Just had a new HVAC system installed by Voltis, and I couldn\'t be happier. The team was professional, the installation was seamless, and our energy bills have already dropped. The lifetime warranty gives us great peace of mind!',
      service: 'HVAC Installation'
    },
    {
      name: 'Michael Chen',
      location: 'Jacksonville, FL',
      rating: 5,
      text: 'Voltis upgraded our electrical panel and installed new lighting throughout our home. The electricians were punctual, respectful of our property, and did excellent work. The upfront pricing was exactly what we paid – no surprises!',
      service: 'Electrical Services'
    },
    {
      name: 'Lisa Anderson',
      location: 'Fort Lauderdale, FL',
      rating: 5,
      text: 'We\'ve been using Voltis for our maintenance plan for 3 years now. They keep our AC and heating running perfectly, and we\'ve avoided any major breakdowns. The technicians are always friendly and thorough. Best decision we made!',
      service: 'Maintenance Plan'
    },
    {
      name: 'David Martinez',
      location: 'St. Petersburg, FL',
      rating: 5,
      text: 'Had a water heater emergency on a Sunday morning. Voltis came out immediately, replaced the unit efficiently, and even helped us choose an energy-efficient model. Outstanding service from start to finish. These guys are the real deal!',
      service: 'Water Heater Replacement'
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-[#F8F9FC] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1B3A6B] mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what Florida homeowners have to say about their experience with Voltis home services.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex items-center justify-center mb-6">
              {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-3xl text-yellow-400"></i>
              ))}
            </div>
            
            <p className="text-xl text-gray-700 text-center mb-8 leading-relaxed italic">
              &ldquo;{testimonials[activeIndex].text}&rdquo;
            </p>
            
            <div className="text-center">
              <p className="text-lg font-bold text-[#1B3A6B]">{testimonials[activeIndex].name}</p>
              <p className="text-sm text-gray-600">{testimonials[activeIndex].location}</p>
              <p className="text-sm text-[#B22234] font-semibold mt-2">{testimonials[activeIndex].service}</p>
            </div>
          </div>

          <button 
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#1B3A6B] hover:text-white transition-all group cursor-pointer"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-700 group-hover:text-white"></i>
          </button>

          <button 
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#1B3A6B] hover:text-white transition-all group cursor-pointer"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-700 group-hover:text-white"></i>
          </button>

          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === activeIndex ? 'bg-[#B22234] w-8' : 'bg-gray-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8 text-center">
          <div className="bg-gradient-to-br from-[#1B3A6B]/5 to-white rounded-xl p-8 border border-[#1B3A6B]/10">
            <div className="w-16 h-16 bg-[#1B3A6B] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-google-fill text-3xl text-white"></i>
            </div>
            <p className="text-3xl font-bold text-[#1B3A6B] mb-2">4.9/5</p>
            <p className="text-sm text-gray-600">Google Reviews</p>
            <p className="text-xs text-gray-500 mt-2">Based on 2,500+ reviews</p>
          </div>
          
          <div className="bg-gradient-to-br from-[#B22234]/5 to-white rounded-xl p-8 border border-[#B22234]/10">
            <div className="w-16 h-16 bg-[#B22234] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-facebook-fill text-3xl text-white"></i>
            </div>
            <p className="text-3xl font-bold text-[#1B3A6B] mb-2">4.8/5</p>
            <p className="text-sm text-gray-600">Facebook Reviews</p>
            <p className="text-xs text-gray-500 mt-2">Based on 1,800+ reviews</p>
          </div>
          
          <div className="bg-gradient-to-br from-[#1B3A6B]/5 to-white rounded-xl p-8 border border-[#1B3A6B]/10">
            <div className="w-16 h-16 bg-[#1B3A6B] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-star-fill text-3xl text-white"></i>
            </div>
            <p className="text-3xl font-bold text-[#1B3A6B] mb-2">5/5</p>
            <p className="text-sm text-gray-600">Yelp Reviews</p>
            <p className="text-xs text-gray-500 mt-2">Based on 1,200+ reviews</p>
          </div>
        </div>
      </div>
    </section>
  );
}
